import UnavailableProduct from '../../react/pages/UnavailableProduct/UnavailableProduct';

import { mountReact } from '../../react/utils/mountReact';

const pageComponents = [
  { path: '/pages/unavailable-product', component: UnavailableProduct },
];

// get window location pathname with removed trailing slash
const url = window.location.pathname && window.location.pathname.replace(/\/$/, '');

const { component } = pageComponents.find(({ path }) => path === url);

mountReact('#ruggable-alpha', component);
